import React, { useState, useEffect, useCallback } from 'react';
import '../../assets/css/common.css';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import UserSearchBox from '../../components/UI/UserSearchBox';
import Pagination from '../../components/UI/Pagination';
import { openAlert, showPopup } from '../../utils/common';
import SectionContainer from '../../components/UI/SectionContainer';
import Modal from '../../components/Layout/Modal';
import Spinner from '../../components/UI/Spinner';
import userService from '../../services/userService';

const PolicyPage = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchKind, setSearchKind] = useState('0');
  const [keyword, setKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const pageSize = 10;
  const pageBlock = 5;

  // page, optional override for kind and keyword
  const fetchList = useCallback(async (page = 1, skArg, kwArg) => {
    setLoading(true);
    try {
      const sk = skArg !== undefined ? Number(skArg) : 0;
      const kwState = kwArg !== undefined ? kwArg : '';
      
      const response = await userService.getPolicyAgreeList(
        page,
        pageSize,
        sk,
        kwState
      );
      
      if (response.success) {
        setList(response.data.policyAgreements);
        setTotalCount(response.data.pagination?.totalCount);
      } else {
        openAlert({ title: '알림', description: response.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '데이터 로드 중 오류가 발생했습니다.';
      openAlert({ title: '알림', description: errorMessage });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchList(currentPage, searchKind, keyword);
  }, [currentPage]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = (directKeyword) => { 
    setCurrentPage(1); 
    // Use directKeyword if provided (from suggestion select), otherwise use keyword from state
    fetchList(1, searchKind, directKeyword !== undefined ? directKeyword : keyword); 
  };
  const handleReset = () => { 
    setSearchKind('0'); 
    setKeyword(''); 
    setCurrentPage(1); 
    // Call fetchList directly with reset values, consistent with new handleSearch signature
    fetchList(1, '0', ''); 
  };

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('terms');
  const [selected, setSelected] = useState(null);

  const openModal = (type, item) => { setModalType(type); setSelected(item); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setSelected(null); };

  const showUserDetail = (idx) => {
    showPopup(`/user/profile/${idx}`, 'userinfo');
  }

  return (
    <SectionContainer title="정보정책 동의여부 조회">
      <Spinner visible={loading} />
      <UserSearchBox
        value={keyword}
        onChange={setKeyword}
        searchKind={searchKind}
        onSelect={setSearchKind}
        onSearch={handleSearch}
        onReset={handleReset}
        onSuggestSelect={selectedVal => { 
          setKeyword(selectedVal); // Update the keyword state
          handleSearch(selectedVal); // And immediately search with this selected value
        }}
        totalCount={totalCount}
      />
      <div className="content_area">
        <div className="table_area">
          <div className="table">
            <table className="policy-page-table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>성명</th>
                  <th>아이디</th>
                  <th>이메일</th>
                  <th>이용약관 동의여부</th>
                  <th>개인정보 동의여부</th>
                  <th>등록시간</th>
                </tr>
              </thead>
              <tbody>
                {!loading && list.length === 0 ? (
                  <tr><td colSpan="7">정보정책 동의여부 조회 내역이 존재하지 않습니다.</td></tr>
                ) : (
                  list.map((item, idx) => (
                    <tr key={idx}>
                      <td style={{cursor: 'default'}}>{(currentPage - 1) * pageSize + idx + 1}</td>
                      <td className="clickable" onClick={() => showUserDetail(item.user.userIdx)} style={{cursor: 'pointer'}}>{item.user.userName}</td>
                      <td style={{cursor: 'default'}}>{item.user.userId}</td>
                      <td style={{cursor: 'default'}}>{item.user.userEmail}</td>
                      <td className="clickable" style={{cursor: 'pointer'}}>
                        <div className="un_line" onClick={() => openModal('terms', item)} dangerouslySetInnerHTML={{ __html: `동의/<span>ver.${item.termsVersion}</span>` }} />
                      </td>
                      <td className="clickable" style={{cursor: 'pointer'}}>
                        <div className="un_line" onClick={() => openModal('privacy', item)} dangerouslySetInnerHTML={{ __html: `동의/<span>ver.${item.privacyVersion}</span>` }} />
                      </td>
                      <td style={{cursor: 'default'}}>{item.regDate}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalCount={totalCount} pageSize={pageSize} pageBlock={pageBlock} onPageChange={setCurrentPage} />
      <Modal
        title={modalType === 'terms' ? '이용약관' : '개인정보방침'}
        visible={showModal}
        onConfirm={closeModal}
        modalClassName="terms_wrap bd"
        className="common"
      >
        <div className="modal-content-wrap" style={{ overflowY: 'auto', textAlign: 'left' }}>
          <div 
            dangerouslySetInnerHTML={{ __html: (modalType === 'terms' ? selected?.terms : selected?.privacy)?.replace(/\n/gi, '<br/>') }} 
          />
        </div>
      </Modal>
    </SectionContainer>
  );
};

export default PolicyPage;
